import React, { useState } from 'react';

const GreetingTab = ({ updateChatTabData,chatTabData }) => {
    const [welcomeMessage, setWelcomeMessage] = useState(chatTabData.welcome_message);
    const [activeDisplayType, setActiveDisplayType] = useState(chatTabData.display_type);

    // Handlers Welcome Message Change
    const handleWelcomeMessageChange = (event) => {
        const value = event.target.value;
        setWelcomeMessage(value);
        updateChatTabData("welcome_message", value);
    };

    // Handle Display Chat Type change
    const handleActiveDisplayTypeChange = (event) => {
        setActiveDisplayType(event.target.value);
        updateChatTabData("display_type", event.target.value);
    };

    return (
        <div className="side-baar-inner-setting">
            <span>Greeting</span>
            <div className="name-tile-row">Welcome Message</div>
            <div className="side-baar-box-header">
                <div className="box-header-row welcome-message">
                    <textarea value={welcomeMessage} onChange={handleWelcomeMessageChange} placeholder="Type Message..." defaultValue={welcomeMessage} />
                </div>
            </div>
            <div className="box-header-row last-border-none">
                <div className="side-baar-box-header">
                    <div className="box-header-row">
                        <span>Greetings Display</span>
                        <div className="left-cnater-right-button">
                            <label className="card-radio-btn">
                                <input type="radio" name="alignment_type" className="card-input-element d-none" value="chat-window-only" onChange={handleActiveDisplayTypeChange} checked={activeDisplayType === "chat-window-only"} />
                                <div className="card card-body">
                                    <div className="content_sub">In Chat Window Only</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GreetingTab;